import { getInflowBackendUrl } from '../../utils/inflowBackendEnvironment';
import { isInflowDemoModeEnabled } from '../../utils/inflowDemoMode';

let pending = null;
let pendingBrand = null;
let pendingPayroll = null;
function context() {
  try {
    const token = localStorage.getItem('token');
    const actor = localStorage.getItem('userId');
    if (!token || !actor || localStorage.getItem('mustChangePassword') === '1' || isInflowDemoModeEnabled()) return null;
    const backend = getInflowBackendUrl();
    const workspace = localStorage.getItem('inflow:acting-workspace-id') || '';
    const scenario = localStorage.getItem('inflow:demo-scenario-id') || 'default';
    return { token, backend, workspace, signature: JSON.stringify([token, actor, backend, workspace, scenario]) };
  } catch { return null; }
}
// Start only on authenticated workspace entry. This is a fresh server decision,
// not persisted authorization; failures use the normal session-refresh path.
export function startModuleAccessBootstrap() {
  if (typeof window === 'undefined' || !/^\/inflow\/(dashboard|today)\/?$/.test(window.location.pathname)) return;
  const captured = context();
  if (!captured) return;
  const request = (url, validate) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const promise = fetch(`${captured.backend}/inflow/${url}`, {
      credentials: 'include', signal: controller.signal,
      headers: { Authorization: `Bearer ${captured.token}`, ...(captured.workspace ? { 'X-Inflow-Workspace-Id': captured.workspace } : {}) },
    }).then(async response => {
      if (!response.ok) return null;
      const data = await response.json();
      return validate(data) ? data : null;
    }).catch(() => null).finally(() => clearTimeout(timeout));
    return { signature: captured.signature, startedAt: Date.now(), promise };
  };
  pending = request('module-access', data => data?.modules && typeof data.modules === 'object' && !Array.isArray(data.modules) && Object.values(data.modules).every(module => typeof module?.hasAccess === 'boolean'));
  // Begin as soon as the server confirms access, without waiting for React's
  // dashboard and banner chunks to mount. Never reuse across session changes.
  pendingPayroll = null;
  pending.promise.then(access => {
    if (context()?.signature !== captured.signature || access?.capabilities?.viewPayroll !== true) return;
    pendingPayroll = request('team/payroll/status', data => Array.isArray(data?.employees) && Boolean(data?.workspaceId));
  });
  pendingBrand = new URLSearchParams(window.location.search).get('tab') === '2'
    ? request('crm/newsletters/brand', data => data && typeof data === 'object' && !Array.isArray(data))
    : null;
}
export async function consumeModuleAccessBootstrap() {
  const captured = context();
  const request = pending;
  if (!request || !captured || captured.signature !== request.signature || Date.now() - request.startedAt > 10000) return null;
  pending = null;
  const data = await request.promise;
  return context()?.signature === request.signature ? data : null;
}

export async function consumeNewsletterBrandBootstrap() {
  const captured = context();
  const request = pendingBrand;
  if (!request || !captured || captured.signature !== request.signature || Date.now() - request.startedAt > 10000) return null;
  pendingBrand = null;
  const data = await request.promise;
  return context()?.signature === request.signature ? data : null;
}

export async function consumePayrollStatusBootstrap(workspace) {
  const captured = context();
  const request = pendingPayroll;
  if (!request || !captured || captured.signature !== request.signature || Date.now() - request.startedAt > 10000) return null;
  pendingPayroll = null;
  const data = await request.promise;
  if (context()?.signature !== request.signature || !data) return null;
  if (workspace && String(data.workspaceId) !== String(workspace)) return null;
  return data;
}
